import { OptimizelyDecideOption } from '@optimizely/react-sdk';

export const FLAG = {
  CAR_PRIZE_DRAW: 'june_car_prize_draw',
  COOKIE_CONSENT_BANNER: 'cookie_consent_banner',
  DEALER_RATINGS_CONSISTENCY_EXPERIMENT: 'dealer_ratings_consistency_experiment',
  DEALER_RATINGS_MEASURING_EXPERIMENT: 'dealer_ratings_measuring_experiment',
  INCODE_DOCS_UPLOAD_COPY: 'incode_docs_upload_copy',
  INCODE_KEEPER_AUTHORIZATION: 'incode_keeper_authorization',
  MODIFICATIONS: 'modifications',
  MW_0_2_GET_THE_APP_BANNER: 'mw_0_2_get_the_app_banner',
  MW_4_1_MILEAGE_REMOVAL: 'mw_4_1_mileage_removal',
  MW_4_5_ESTIMATED_SALE_PRICE_REMOVAL: 'mw_4_5_estimated_sale_price_removal',
  MW_4_6_PAAS_FIRST_QUESTION: 'mw_4_6_paas_first_question',
  MW_5_3_HERO_FINANCE_QUESTION: 'mw_5_3_hero_finance_question',
  MW_HIDE_NON_ELIGIBLE_SIGNUP_FORM: 'mw_hide_non-eligible_signup_form',
  OFFER_ACCEPTANCE_SIMILAR_VEHICLES: 'offer_acceptance_similar_vehicles',
  OFFER_POSITIONING_EXPERIMENT: 'offer_positioning_experiment',
  PAAS_ADDITIONAL_PHOTOS_UPLOAD: 'paas_additional_photos_upload',
  PRICE_RANGE_EXPERIMENT: 'price_range_experiment',
  QR_CONTAINER_CTA_COPY: 'qr_container_cta_copy',
  SWA_ALWAYS_ON: 'swa_always_on',
  UNIFIED_SELLER_ACCEPTANCE_ABOVE_RESERVE: 'unified_seller_acceptance_above_reserve',
  UNIFIED_SELLER_ACCEPTANCE_BELOW_RESERVE: 'unified_seller_acceptance_below_reserve',
  UNIFIED_SELLER_ACCEPTANCE_BELOW_RESERVE_AA: 'unified_seller_acceptance_below_reserve_aa',
  VRM_AA: 'vrm_aa',
} as const;

export const EVENT = {
  AGENT_SUPPORT_CONTACTED: 'agent_support_contacted',
  COOKIE_BANNER_ACCEPT_ALL_CLICKED: 'cookie_banner_accept_all_clicked',
  COOKIE_BANNER_ESSENTIAL_ONLY_CLICKED: 'cookie_banner_essential_only_clicked',
  COOKIE_BANNER_LEARN_MORE_CLICKED: 'cookie_banner_learn_more_clicked',
  COOKIE_PREFERENCE_CENTRE_ANALYTICS_TOGGLED: 'cookie_preference_centre_analytics_toggled',
  COOKIE_PREFERENCE_CENTRE_MARKETING_TOGGLED: 'cookie_preference_centre_marketing_toggled',
  EARLY_DOCS_UPLOAD_CTA_CLICKED: 'early_docs_timeline_cta_clicked',
  EARLY_DOCS_UPLOAD_SUCCESS: 'early_docs_timeline_upload_success',
  ENQUIRY_CREATED: 'enquiry_created',
  ENQUIRY_LOADED: 'enquiry_load',
  EXPIRED_LINK_LOAD: 'expired_link_load',
  GET_THE_APP_BANNER_CLICKED: 'get_app_banner_clicked',
  GET_THE_APP_BANNER_HIDDEN: 'get_app_banner_hidden',
  HERO_MILEAGE_CTA_CLICKED: 'valuations_hero_mileage_cta_clicked',
  HERO_VRM_CTA_CLICKED: 'valuations_hero_vrm_cta_clicked',
  MW_5_3_HERO_FINANCE_CONTINUE_CLICKED: 'mw_5_3_hero_finance_continue_clicked',
  MW_5_3_HERO_FINANCE_RADIO_SELECTED: 'mw_5_3_hero_finance_radio_selected',
  MW_5_3_PAAS_FINANCE_CONTINUE_CLICKED: 'mw_5_3_paas_finance_continue_clicked',
  NON_MARKETPLACE_VALUATION_CTA_CLICKED: 'non_marketplace_valuation_cta_clicked',
  NON_MARKETPLACE_VALUATION_JOURNEY: 'non_marketplace_valuation_journey',
  OFFER_SELECT: 'offer_select',
  PERSONAL_DETAILS_UPDATED: 'personal_details_updated',
  PHOTO_HANDOVER_SEEN: 'photo_handover_seen',
  PROFILE_EXISTING_PHOTOS_ANSWERED: 'profile_existing_photos_answered',
  PROFILE_FIRST_QUESTION_ANSWERED: 'profile_first_question_answered',
  PROFILE_FIRST_QUESTION_SEEN: 'profile_first_question_seen',
  PS_ACCEPT_OFFER_CTA_CLICKED: 'ps_accept_offer_cta_clicked',
  PS_ACCEPT_OFFER_PAGE_LOADED: 'ps_accept_offer_page_loaded',
  PS_ACCEPT_OFFER_PHONE_CLICKED: 'ps_accept_offer_phone_clicked',
  PS_COMPLETE_SALE_CTA_CLICKED: 'ps_complete_sale_cta_clicked',
  SIGN_IN_CTA_CLICKED: 'sign_in_cta_clicked',
  SIGN_IN_LOADED: 'sign_in_load',
  SIGN_IN_SUCCESS_LOAD: 'sign_in_success_load',
  SIGN_UP_CTA_CLICKED: 'sign_up_cta_clicked',
  SIGN_UP_LOADED: 'sign_up_load',
  SIGN_UP_TOOLTIP_SHOW: 'contact_details_page_info_hover',
  SMV_MILEAGE_CTA_CLICKED: 'smv_mileage_cta_clicked',
  VALUATIONS_LOADED: 'valuations_load',
  VALUATIONS_MILEAGE_CTA_CLICKED: 'valuations_mileage_cta_clicked',
  VALUATIONS_MILEAGE_UPDATED: 'valuations_mileage_updated',
  VEHICLE_HUB_VIEW_SECTIONS: 'vehicle_hub_view_sections',
  VEHICLE_HUB_VIEW_VEHICLE_INFORMATION: 'vehicle_hub_view_vehicle_information',
} as const;

export const EXPERIMENT_DECISIONS_HEADER = 'experiment-decisions';

export const DISABLE_DECISION = [OptimizelyDecideOption.DISABLE_DECISION_EVENT];
